export enum QueryDocumentNameEnum {
  ContentVersion = 'ContentVersion',
  ContentDocument = 'ContentDocument',
}
